import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge, { BadgeType } from '../../components/ui/Badge/Badge';

// A package the warehouse created during putaway (spec 2026-10-16 B): the
// merchant never announced it. Renders nothing for announced packages and
// while the backend does not send the flag yet. Lives in its own module so
// the table and the overlay can both import it without a cycle.
export function NotAnnouncedBadge({ announced }: { announced?: boolean }) {
  const { t } = useTranslation();
  if (announced !== false) return null;
  // Badge renders a bare dot unless `expanded`; the label must be visible.
  return <Badge label={t('inbound.not_announced')} type={BadgeType.Warning} expanded />;
}

export default NotAnnouncedBadge;
